import venusLogo from "@/assets/venus-logo.png";

// Real brand logo (extracted from company PDF)
export const LogoLockup = ({ className = "h-11 w-auto" }) => (
  <img
    src={venusLogo}
    alt="Venus Green Renewables & Energy Pvt. Ltd."
    className={className}
    data-testid="site-logo"
  />
);
